import React from 'react';

export const TITULOS = {
  exito: 'Listo',
  error: 'Error',
  aviso: 'Atención',
  info: 'Información',
};

const svg = { width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round', 'aria-hidden': true };

const ICONOS = {
  exito: (
    <svg {...svg}>
      <circle cx="12" cy="12" r="10" />
      <path d="m8 12.5 3 3 5-6" />
    </svg>
  ),
  info: (
    <svg {...svg}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 11v6" />
      <path d="M12 7.5h.01" />
    </svg>
  ),
  aviso: (
    <svg {...svg}>
      <path d="M10.3 3.9 2.4 17.5A2 2 0 0 0 4.1 20.5h15.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9.5v4" />
      <path d="M12 17h.01" />
    </svg>
  ),
  error: (
    <svg {...svg}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 7.5v5" />
      <path d="M12 16.5h.01" />
    </svg>
  ),
};

/** Cuerpo del toast: ícono por tipo, título en negro y mensaje debajo en gris. */
export default function ContenidoToast({ tipo = 'info', titulo, mensaje }) {
  return (
    <div className="st-contenido">
      <span className={`st-icono st-icono--${tipo}`}>{ICONOS[tipo] || ICONOS.info}</span>
      <div className="st-texto">
        <strong className="st-titulo">{titulo}</strong>
        {mensaje ? <span className="st-mensaje">{mensaje}</span> : null}
      </div>
    </div>
  );
}
